import { component } from 'picoapp';
import { clear } from 'utils/node';

export default component(async (node) => {
  const {
    sectionId, productId, baseUrl, limit,
  } = node.dataset;

  const initRecommendations = async () => {
    const params = new URLSearchParams({
      section_id: sectionId,
      product_id: productId,
      limit,
    });
    const response = await fetch(`${baseUrl}?${params}`);

    if (response.status >= 200 && response.status < 300) {
      const container = document.createElement('div');
      container.innerHTML = await response.text();

      clear(node);
      node.insertAdjacentHTML(
        'beforeend',
        container.querySelector('[data-component]').innerHTML,
      );

      container.remove();
    } else {
      throw new Error(`Could not fetch product recommendations. Server responded with: ${response.status}`);
    }
  };

  initRecommendations();
});
